import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UserActions from "../../../../../Redux/actions/userActions";
import { getUserDefaultModules } from "../../../../../Redux/reducer/users";
import * as instanceActions from "../../../../../Redux/api";
import CheckBox from "canvas-core-react/lib/Checkbox";

import Modal from "../../../../utils/customModal";
import {
  errorContainer,
  loadingHtml,
  sucessInfoModal,
} from "../../../../utils/functions";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";

export class UserProviderRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        show: false,
        type: "loading",
        modalMessage: { title: "", message: "" },
      },
      modalContent: null,
      openModal: false,
      modalType: "",
      modulo: [],
      contentReady: false,
    };
  }

  componentDidMount() {
    const {
      actions: { getUserDefaultModules },
      match: { params },
    } = this.props;

    const { modal } = this.state;
    modal.show = true;
    this.setState({ modal });

    return getUserDefaultModules(params.providerId).then((response) => {
      modal.show = false;
      this.setState({ modulo: response.data, contentReady: true, modal });
    });
  }

  componentWillUnmount() {
    this.setState({ contentReady: false, modulo: [] });
  }

  moduleHandlerChange = (event) => {
    const { modulo } = this.state;
    var modId = event.target.name.split("-")[0];
    var permissionId = event.target.name.split("-")[1];
    if (modulo[modId].permissions[permissionId] !== undefined) {
      modulo[modId].permissions[permissionId].assigned = event.target.checked;
    }
    this.setState({ modulo });
  };

  providerUserData = () => {
    const { modulo } = this.state;
    const { user } = this.props;

    var modules = [];
    modulo.map((mod) => {
      let permissions = [];
      Object.keys(mod.permissions).map((key) =>
        permissions.push({
          id: parseInt(mod.permissions[key].id, 10),
          assigned: mod.permissions[key].assigned,
        })
      );

      modules.push({ id: mod.id, permissions });
    });

    return {
      data: {
        codUser: user.codUser,
        email: user.email,
        firstName: user.firstName,
        identification: user.identification,
        lastName: user.lastName,
        phone: user.phone,
        status: user.status,
        modules,
      },
    };
  };

  createUser = () => {
    const { modal } = this.state;
    const {
      match: { params },
      instance: { instanceAction },
      hasErrors,
    } = this.props;

    if (hasErrors()) return;

    modal.show = true;
    this.setState({ modal });

    return instanceAction(
      `users/${params.id}/${params.countryCode}/${"PRO"}`,
      "put",
      this.providerUserData()
    )
      .then(() => {
        modal.type = "success";
        modal.modalMessage = {
          title: "Estimado usuario",
          message: "La operación fue realizada con éxito",
        };
        this.setState({ modal });
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.modalMessage = {
            title: notification.message,
            message: notification.description,
          };
        }
        modal.type = "error";
        this.setState({ modal });
      });
  };

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.type = "loading";
    modal.modalMessage = { title: "", message: "" };
    this.setState({ modal });
    this.props.endStep();
  };

  getModalContent = () => {
    const { type, modalMessage } = this.state.modal;
    var buttons = {
      SelBtn: {
        text: "Continuar",
        action: () => this.closeModal(),
      },
    };
    switch (type) {
      case "loading":
        return loadingHtml();
      case "success":
        return sucessInfoModal(
          modalMessage.title,
          modalMessage.message,
          buttons
        );
      case "error":
        return errorContainer(
          modalMessage.title,
          modalMessage.message,
          buttons
        );
    }
  };

  render() {
    const { user, disabled } = this.props;
    const { modulo } = this.state;

    return (
      user !== null && (
        <div>
          <div>
            {modulo.map((mod, key) => (
              <div key={`${mod.id}-${key}`} className="loaded-module-user">
                <div className="flex-element">
                  <p>{mod.displayName}</p>
                  {/* {this.pendingData(mod.id)} */}
                </div>
                <div className="roles">
                  {mod.permissions.map((permission, moduleKey) => (
                    <CheckBox
                      key={`${moduleKey}-${permission.code}-${permission.code}`}
                      id={`${permission.id}-${permission.id}`}
                      name={`${key}-${moduleKey}`}
                      label={permission.displayName}
                      defaultChecked={permission.assigned}
                      onChange={(event) => this.moduleHandlerChange(event)}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="form-actions clearfix">
            <SecondaryButton
              id="closeRoles"
              className="btnLimpiar"
              onClick={this.props.closeStep}
            >
              Cancelar
            </SecondaryButton>

            <SecondaryButton
              id="sendForApproval"
              className="btnAgregar"
              disabled={disabled}
              onClick={() => this.createUser()}
            >
              Guardar
            </SecondaryButton>
          </div>
          <Modal
            key={`provider-manual`}
            show={this.state.modal.show}
            handleClose={
              this.state.modal.type == "loading"
                ? undefined
                : () => this.closeModal()
            }
          >
            {this.getModalContent()}
          </Modal>
        </div>
      )
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    modulo: getUserDefaultModules(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(UserActions, dispatch),
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatch)(UserProviderRoles)
);
